export const ROUTES = {
    // EDIT_PROFILE: 'EDIT_PROFILE',
    CHANGE_PASSWORD: 'CHANGE_PASSWORD',
    TERMS_CONDITIONS: 'TERMS_CONDITIONS',
    PRIVACY_POLICY: 'PRIVACY_POLICY',
    BLACK_JACK_RULES: 'BLACK_JACK_RULES',
    BACCARAT_RULES: 'BACCARAT_RULES',
    SLOT_MACHINE_RULES: 'SLOT_MACHINE_RULES',
    PRIZE_POOL_RULES: 'PRIZE_POOL_RULES',
    DIGIT_DREAM_RULES: 'DIGIT_DREAM_RULES',
    CONTACT_US: 'CONTACT_US',
    COIN_CONVERSION: 'COIN_CONVERSION',
};
